module.exports = __webpack_public_path__ + "static/media/iphoneimage.76be3f4b.png";